module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7Dhd3"))).then(() => parcelRequire('dJXJK'));